import ClickAwayListener from 'react-click-away-listener';

import StyledButton from '../StyledButton';
import { IAdminModal } from './AdminModal.types';
import GifLoader from '../Loading/GifLoader';

import Cancelicon from '../../svgs/Cancelicon';
import KaboLogo from '../../svgs/KaboLogo';
import SuccessNewIcon from '../../svgs/SuccessNewIcon';

import AdminModalStyles from './AdminModal.module.scss';

const AdminModal = ({
  children,
  isShow,
  onClickAway,
  onClose,
  className,
  childrenClassName,
  contentClassName,
  isTopIcon = true,
  topIcon,
  isShowCloseIcon = true,
  closeClassName,
  headText,
  subText,
  actionBtnName,
  handleModalAction,
  isSuccess = false,
  isLoading = false,
  isActionBtnDisabled = false,
  hideLogo = false,
  cancelBtnClass,
  actionBtnClass,
  titleClassName,
  subTitleClassName,
}: IAdminModal) => {
  if (!isShow) return null;

  const handleClick = () => {
    if (isSuccess) return onClose();
    handleModalAction();
  };

  return (
    <div className={`${AdminModalStyles.modal} ${className}`}>
      <ClickAwayListener onClickAway={() => onClickAway()}>
        {isLoading ? (
          <div className={AdminModalStyles.modal__loaderWrapper}>
            <GifLoader height="120px" />
          </div>
        ) : (
          <div className={`${AdminModalStyles.modal__content}  ${contentClassName}`}>
            {isShowCloseIcon && (
            <div className={`${AdminModalStyles.modal__close} ${closeClassName}`} onClick={() => onClose()}>
              <Cancelicon color="#667085" width="8px" height="8px" />
            </div>
            )}

            <div className={`${AdminModalStyles.modal__children} ${childrenClassName}`}>
              {isTopIcon && (
              <div className={AdminModalStyles.modal__topIcon}>
                {isSuccess ? <SuccessNewIcon /> : topIcon}
              </div>
              )}
              {headText && (<h4 className={`${AdminModalStyles.modal__title} ${titleClassName}`}>{headText}</h4>)}
              {subText && (<p className={`${subTitleClassName || AdminModalStyles.modal__subTitle}`}>{subText}</p>)}
              {children}
              <div className={AdminModalStyles.modal__btnWrapper}>
                {!isSuccess && (
                <StyledButton
                  name="CANCEL"
                  border="1px solid black"
                  fontSize="14px"
                  textTransform="upperCase"
                  height="44px"
                  width="100%"
                  backgroundColor="#ffffff"
                  color="#718096"
                  borderRadius="4px"
                  fontWeight={900}
                  onClick={() => onClose()}
                  hideButtonClass={cancelBtnClass}
                />
                )}

                <StyledButton
                  name={isSuccess ? 'OKAY' : actionBtnName}
                  border="none"
                  fontSize="14px"
                  height="44px"
                  width="100%"
                  textTransform="upperCase"
                  backgroundColor="black"
                  color="white"
                  borderRadius="4px"
                  fontWeight={900}
                  disabled={isActionBtnDisabled}
                  onClick={handleClick}
                  hideButtonClass={actionBtnClass}
                />
              </div>

              {!isSuccess && !hideLogo && (
              <span className={AdminModalStyles.modal__bottomLogoWrapper}>
                <KaboLogo className={AdminModalStyles.modal__kaaboLogo} />
              </span>
              )}
            </div>
          </div>
        )}
      </ClickAwayListener>
    </div>
  );
};

export default AdminModal;
